import React from 'react';

export const ErrorHandlingContext = React.createContext({});

export const ErrorHandlingProvider = ({ children }) => {
  const [networkError, setNetworkError] = React.useState(false);
  const value = {
    networkError,
    setNetworkError,
  };
  return (
    <ErrorHandlingContext.Provider value={value}>
      {children}
    </ErrorHandlingContext.Provider>
  );
};
